import { useCallback, useEffect, useState } from "react";
import TableLayout from "../components/layouts/TableLayout";
import AddOrder from "../components/orders/AddOrder";
import { deleteData, getData, updateData } from "../helpers/api";
import { Badge, Button, Modal, Space, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined, ExclamationCircleFilled, FileAddOutlined, CheckCircleOutlined, PhoneOutlined, WhatsAppOutlined, RedoOutlined } from "@ant-design/icons"
import ModalComponent from "../components/Modal";
import DisplayOrder from "../components/orders/DisplayOrder";
import { ConfirmationStatusElement, INITIAL_ACTIONS, roles, rolesConst, rolesDoesNotHaveAddOrders } from "../constants/others";
import { openNotification } from "../helpers/alerts";
import withRoleProtection from "../components/withRoleProtection";
import FilterOrder from "../components/orders/FilterOrder";
import { getLocalStorage } from "../helpers/localstorage";
import UpdateDeliveryStatus from "../components/orders/UpdateDeliveryStatus";
import AddingNote from "../components/orders/AddingNote";
import { changeColor } from "../utils/changeColor";
import moment from "moment";

const { confirm } = Modal;
const INITIAL_VALUE = {
    name: "",
    phone: "",
    address: "",
    price: null,
    bmdCity: undefined,
    orderDate: undefined,
    orders: [{
        product: undefined,
        unit: null
    }],
    confimationStatus: ConfirmationStatusElement.Confirmed,
    deliveryCompany: undefined,
    deliveryCompanyKey: undefined,
    content: ""
}


const Orders = () => {
    const [order, setOrder] = useState(INITIAL_VALUE)
    const [orders, setOrders] = useState([])
    const [totalOrders, setTotalTotalOrders] = useState(1);
    const [filter, setFilter] = useState({})
    const [paginationSetting, setPaginationSetting] = useState({
        page: 1,
        limit: 10
    })
    const [addNoteForManagement, setAddNoteForManagement] = useState({ orderId: null, addingNote: false });
    const [updateDeliveryStatus, setUpdateDeliveryStatus] = useState({ orderId: null, isUpdatedeliveryStatus: false })
    const user = getLocalStorage("auth")?.user
    const columns = [
        {
            title: "Date de comande",
            dataIndex: "orderDate",
            key: "orderDate",
            render: (text) => <div>{moment(text).format('YYYY-MM-DD')}</div>
        },
        {
            title: "Nom",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Téléphone",
            dataIndex: "phone",
            key: "phone",
            render: (text, record) => <div style={record.duplicateCount > 0 ? { color: "red" } : {}}>
                {text} {record.duplicateCount > 0 && <Badge count={record.duplicateCount} />}
            </div>
        },
        {
            title: "Prefix",
            dataIndex: "prefix",
            key: "prefix",
        },
        {
            title: "Produits",
            dataIndex: "productName",
            key: "productName",
        },
        {
            title: "Prix",
            dataIndex: "price",
            key: "price",
        },
        {
            title: "Ville",
            dataIndex: "cityName",
            key: "cityName",
        },
        {
            title: "Code",
            dataIndex: "codeColis",
            key: "codeColis",
        },
        {
            title: "Confirmation statut",
            dataIndex: "confimationStatus",
            key: "confimationStatus",
        },
        {
            title: "Livraison statut",
            dataIndex: "deliveryStatus",
            key: "deliveryStatus",
            render: (text, record) => <>{record.confimationStatus === 'confirmée' ? <div style={changeColor(text)}>{text}</div> : <div></div>}</>
        },
        {
            title: "Date de saisie",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text) => <div>{moment(text).format('YYYY-MM-DD HH:mm')}</div>
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (text, record) => {
                return (
                    <Space size="middle">
                        <Tooltip placement="bottom" title={"Consulter la commande"}>
                            <span>
                                <EyeOutlined
                                    onClick={() => { setOrder({ ...record, display: true }) }}
                                />
                            </span>
                        </Tooltip>
                        {user?.role === rolesConst.SuperAdmin && <span>
                            <DeleteOutlined
                                onClick={() => { showDeleteConfirm(record.id) }}
                            />
                        </span>}
                        {((record.deliveryStatus !== "Livré" && ![rolesConst.Follow, rolesConst.SuperAdmin].includes(user?.role)) ||
                            (record.deliveryStatus === "Livré" && [rolesConst.SuperAdmin].includes(user?.role)))
                            && <span>
                                <EditOutlined
                                    onClick={() => {
                                        if ([rolesConst.Deliveryman, rolesConst.SuperAdmin].includes(user?.role)) {
                                            setUpdateDeliveryStatus({ orderId: record.id, isUpdatedeliveryStatus: true })
                                        } else {
                                            setOrder({
                                                ...record,
                                                bmdCity: record?.bmdCity?.id,
                                                edit: true,
                                                deliveryCompany: record.deliveryCompany.id,
                                                deliveryCompanyKey: parseInt(record.deliveryMan?.id) || record.deliveryCompanyKey?.id,
                                                orders: record.orderedProduct.map(el => ({
                                                    product: el.product.id,
                                                    unit: el.unit,
                                                    id: el.id
                                                })),
                                            })
                                        }
                                    }}
                                />
                            </span>}
                        {![rolesConst.Deliveryman, rolesConst.SuperAdmin].includes(user?.role) && <span>
                            <Tooltip placement="bottom" title={"Ajouter note"}>
                                <FileAddOutlined
                                    onClick={() => { setAddNoteForManagement({ orderId: record.id, addingNote: true }) }}
                                />
                            </Tooltip>
                        </span>}
                        {record.noteCount > 1 ? <span>{record.noteCount + " "}<CheckCircleOutlined style={{ fontSize: '16px', color: '#08c' }} /></span> : null}
                        <a target="_blank" href={`tel:${record.phone}`} rel="noreferrer"><PhoneOutlined style={{ fontSize: '16px', color: '#5546ff' }} /></a>
                        <a target="_blank" href={`https://wa.me/${record.phone}`} rel="noreferrer"><WhatsAppOutlined style={{ fontSize: '16px', color: '#0cc143' }} /></a>
                        {[rolesConst.Management, rolesConst.SuperAdmin].includes(user?.role) && !record.codeColis && record.bmdCity && <RedoOutlined onClick={()=>regenerateCodeColis(record.id)} />}
                    </Space>
                )
            },
        }
    ]

    const handleCancel = () => {
        setOrder({ ...INITIAL_VALUE, ...INITIAL_ACTIONS })
        setUpdateDeliveryStatus({ orderId: null, isUpdatedeliveryStatus: false })
        setAddNoteForManagement(false);
    }

    const regenerateCodeColis=async (orderId)=>{
        try {
            await updateData(`/orders/code-colis/${orderId}`)
        } catch (error) {
            openNotification(`Erreurs côté serveur`, 'error')
        }
    }
    const getOrders = useCallback(async () => {
        try {
            const res = await getData("/orders", {
                ...paginationSetting,
                ...filter
            });
            setOrders(res.data.orders.map((order) => ({
                ...order,
                productName: order.orderedProduct.map((el) => `${el.product.name}*${el.unit}`).join(','),
                cityName: order.senditCity?.name || order.bmdCity?.name,
                prefix: `${order.user.prefix} 0${order.id}`,
                noteCount: order.note.length

            })))
            setTotalTotalOrders(res.data.total)
        } catch (error) {
            console.log("erreur")
        }
    }, [filter, paginationSetting])

    const showDeleteConfirm = (productId) => {
        confirm({
            title: 'Vous êtes sûr de supprimer ce produit ?',
            icon: <ExclamationCircleFilled />,
            okText: 'Suprimer',
            okType: 'danger',
            cancelText: 'Anuler',
            onOk() {
                deleteOrder(productId)
            },
        });
    };

    const deleteOrder = async (orderId) => {
        try {
            await deleteData(`/orders/${orderId}`)
            getOrders()
        } catch (error) {
            openNotification(`Erreurs côté serveur`, 'error')
        }
    }

    useEffect(() => {
        getOrders()
    }, [filter, getOrders])

    const handleAfterAction = () => {
        handleCancel()
        getOrders()
    }
    return (
        <>
            {addNoteForManagement.addingNote && <AddingNote
                isModalOpen={addNoteForManagement.addingNote}
                orderId={addNoteForManagement.orderId}
                handleCancel={handleCancel}
                handleAfterAddingNote={handleAfterAction}
            />}
            {updateDeliveryStatus.isUpdatedeliveryStatus && <UpdateDeliveryStatus
                isModalOpen={updateDeliveryStatus.isUpdatedeliveryStatus}
                handleCancel={handleCancel}
                orderId={updateDeliveryStatus.orderId}
                handelAfterAddingNote={handleAfterAction}
            />}
            {(order.add || order.edit) && <AddOrder
                handleAfterAddingOrder={handleAfterAction}
                initialValue={order}
                isModalOpen={order.add || order.edit}
                handleCancel={handleCancel}
            />}
            {
                order.display && <ModalComponent
                    isModalOpen={order.display}
                    handleCancel={handleCancel}
                    title="Les informations de la commandes"
                >
                    <DisplayOrder order={order} />
                </ModalComponent>
            }
            <FilterOrder
                setFilter={setFilter}
                filter={filter}
            />
            <TableLayout
                columns={columns}
                total={totalOrders}
                dataSource={orders}
                getData={(page, pageSize) => { setPaginationSetting({ page, limit: pageSize }) }}
                displayAddBtn={rolesDoesNotHaveAddOrders.includes(user?.role.toLowerCase())}
                setAddElementModal={() => { setOrder({ ...INITIAL_VALUE, add: true }) }}
            />
        </>
    );
}

export default withRoleProtection(Orders, ['super admin', 'Confirmation messenger', 'Confirmation whatsApp', 'Confirmation instagram', 'Confirmation convertion', 'Gestion', 'Livreur', 'Suivie']);